import { landingPageApi } from "@services/landingPage";
import { authApi } from "@services/authApi";
import { formAssignmentsApi } from "@services/formAssignments";
import { dataFormsApi } from "@services/dataFormsApi";
import { patientsApi } from "@services/patientsApi";
import { fastrAppLinksApi } from "@services/fastrAppLinks";
import { featureFlagsApi } from "@services/featureFlagsApi";

const apiList = [
  landingPageApi,
  authApi,
  formAssignmentsApi,
  dataFormsApi,
  patientsApi,
  fastrAppLinksApi,
  featureFlagsApi,
];

export const apiHelper = {
  apiList,
};
const apiReducers = {
  [landingPageApi.reducerPath]: landingPageApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [formAssignmentsApi.reducerPath]: formAssignmentsApi.reducer,
  [dataFormsApi.reducerPath]: dataFormsApi.reducer,
  [patientsApi.reducerPath]: patientsApi.reducer,
  [fastrAppLinksApi.reducerPath]: fastrAppLinksApi.reducer,
  [featureFlagsApi.reducerPath]: featureFlagsApi.reducer,
};

export const getApiReducers = () => {
  return apiReducers;
};
export const getApiMiddlewares = () => {
  return apiList.map((api) => api.middleware);
};
